import { Col, Row } from "reactstrap";
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";

function ApplicationAboutView() {

    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Acerca de nosotros', href: '' }
    ];

    return (
        <MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
            <CenterCenterVerticalContainer>
                <Row>
                    <Col>
                        <h1>Acerca de Nosotros</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        Here goes the content for this page
                    </Col>
                </Row>
            </CenterCenterVerticalContainer>
        </MainPageComponent>
    );
}

export default ApplicationAboutView;